import { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { Outlet, useLocation } from 'react-router-dom';

export default function Estructura() {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const location = useLocation();

  // Cierra el drawer del menú al navegar
  useEffect(() => {
    setMenuAbierto(false);
  }, [location.pathname]);

  return (
    <div className="h-screen bg-gray-200 flex flex-col font-sans" style={{ height: "100dvh" }}>
      {/* Navbar arriba */}
      <Navbar onToggleMenu={() => setMenuAbierto((v) => !v)} />

      {/* Contenido dividido en Sidebar y contenido principal */}
      <div className="flex flex-1 overflow-hidden">
        <Sidebar abierto={menuAbierto} onCerrar={() => setMenuAbierto(false)} />
        <main className="flex-1 bg-gray-200 p-1 md:p-4 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
